import * as React from "react";
import ArticleService from "../../Services/articleService";
import {Col, Container, Row} from "reactstrap";
import {Avatar, Badge, Breadcrumb, Button, Icon, Popover, Select, Upload} from "antd";
import alertService from "../../Services/alertService";
import MagazineService from "../../Services/magazineService";

const { Option } = Select;

export class MassiveImport extends React.Component {

    constructor(props) {
        super(props)
        document.title = "Polar - Import articles"
        this.props.showUserBadge(false);
        this.state = {
            filename: '',
            success: null,
            errorMessage: '',
            dropdownOptions: [],
            selectedMagazine: 1,
        }

        this.articleService = new ArticleService(this.props.token);
        this.magazineService = new MagazineService(this.props.token);
        this.handleUpload = this.handleUpload.bind(this);
        this.reset = this.reset.bind(this);
    }

    componentDidMount() {
        this.fetchDropdownOptions();
    }

    fetchDropdownOptions = async () => {
        try {
            const response = await this.magazineService.getMagazineList({});
            const options = response.data.data.map(option => ({
                id: option.id,
                name: option.name
            }));
            this.setState({ dropdownOptions: options });
        } catch (error) {
            console.error('Error fetching dropdown options:', error);
            this.setState({ errorMessage: 'Failed to fetch magazine list' });
        }
    }

    renderOptions = () => {
        return this.state.dropdownOptions.map(option => {
            if (!option.id || !option.name) {
                console.error('Invalid option structure:', option);
                return null;
            }
            return (
                <Option key={option.id} value={option.id}>
                    {option.name}
                </Option>
            );
        });
    };

    handleSelectChange = (value) => {
        this.setState({ selectedMagazine: value });
    };

    getSelectedMagazineName = () => {
        const selectedOption = this.state.dropdownOptions.find(option => option.id === this.state.selectedMagazine);
        return selectedOption ? selectedOption.name : '';
    };

    goBack() {
        if(document.referrer) //exist prev url
            return window.history.back()
        else
            return window.open("/archive/articles", '_self');
    }

    goArticles() {
        return window.open("/archive/articles", '_self');
    }

    handleUpload(e){
        const file = e.file;
        this.setState({ filename: file.name })

        var formData = new FormData();
        formData.append("file", file)

        const correctType = file.name.endsWith(".xlsx");
        if (!correctType) {
            this.setState({ errorMessage: 'file not allowed' })
            return;
        }

        this.upload(formData)
    }


    upload(formData) {
        this.props.loader(true)
        this.articleService.massiveImport(formData, this.state.selectedMagazine)
        .then(response => {
            if (response.data.ok) {
                alertService.setAlert('success', 'Articles import');
                this.setState({ success: true })
                this.props.loader(false)
                setTimeout(() => this.reset(), 5000)
            }
            else {
                this.setState({ success: false, errorMessage: response.data.errorMessage })
                this.props.loader(false)
                setTimeout(() => this.reset(), 60000)
            }
        })
        .catch(err => {
            this.setState({ success: false, errorMessage: err.toString() })
            this.props.loader(false)
            setTimeout(() => this.reset(), 60000)
        })
    }


    reset() {
        this.setState({ success: null, errorMessage: '', filename: '' })
    }


    render() {
        const props = {
            beforeUpload: (file) => {
                return false; //serve per rimuovere la action
            }
        };

        const alertOK = <div>
            <h6 className="pt-4" style={{ color: "green" }}>Success</h6>
            <p><strong>Your mass article import has been completed without issues.</strong></p>
            <strong style={{ textDecoration: 'underline', cursor: 'pointer' }} onClick={this.goArticles}>Go to articles.</strong>
        </div>

        const alertKO = <div>
            <h6 className="pt-4" style={{ color: "darkred" }}>Error</h6>
            <p><strong>Importing items encountered the following error:</strong></p>
            <p><strong>{this.state.errorMessage}</strong></p>
        </div>

        return (
            <Container fluid={true} className="mb-5">
                <Row>
                    <Col sm="12" style={{ display: 'inline-flex', height: '0', justifyContent: "end" }} className="mb-4">
                        <Breadcrumb className="bread">
                            <Breadcrumb.Item>
                                <Button className="fmk_button primary mr-2" style={{bottom: 3}} onClick={() => this.goBack()}>
                                    <Icon type="caret-left" />
                                </Button>
                                <strong className="h5 font-weight-bold" style={{color: 'black'}}>
                                    Articles massive import
                                </strong>
                            </Breadcrumb.Item>
                        </Breadcrumb>
                        <div className="plusButtonCat">
                            <Badge>
                                <Popover placement="bottomRight" content={this.props.usercontent} trigger="click">
                                    <div style={{cursor: 'pointer'}}>
                                        <Avatar style={{backgroundColor: this.props.avatarColor, marginLeft: '5px'}}
                                                icon="user"/>
                                    </div>
                                </Popover>
                            </Badge>
                        </div>
                    </Col>

                    <Col sm="12" className="text-center">
                        <h4 className="pb-2">Import Articles</h4>
                        <div style={{ display: 'inline-flex' }}>
                            <Select
                                style={{ minWidth: 250 }}
                                className={'selectWizard darkSelect handleTyp'}
                                placeholder="Select a magazine"
                                value={this.state.selectedMagazine}
                                onChange={this.handleSelectChange}
                            >
                                {this.renderOptions()}
                            </Select>
                        </div>
                        <p className="mb-4"><strong>Import Articles from File Maker export (.xlsx)</strong></p>
                        <div style={{display: 'flex', justifyContent: 'center'}}>
                            <Upload accept=".xlsx" onChange={this.handleUpload} fileList={[]} {...props}>
                                <Button className="fmk_button"> <Icon type="upload"/> Upload</Button>
                            </Upload>
                            <p className="ml-3 mt-1">{this.state.filename}</p>
                        </div>

                        {this.state.success === true ? alertOK : this.state.success === false ? alertKO : ''}                    
                    </Col>

                </Row>
            </Container>
        )
    }

}



// WEBPACK FOOTER //
// ./src/FileMaker/Articles/MassiveImport.js